// src/pages/admin/Categorias.js
import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const ICONOS = ['🌿','🧴','🍼','💆','💋','👕','🐾','🌱','♻️','🔄','🌸','🍃','🌺','💚','🫧'];
const EMPTY = { nombre:'', descripcion:'', icono:'🌿' };

export default function Categorias() {
  const [categorias, setCategorias] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(EMPTY);
  const [editId, setEditId] = useState(null);

  const load = () => api.get('/categorias/todas').then(r => setCategorias(r.data)).catch(()=>{});
  useEffect(() => { load(); }, []);

  const abrir = (c = null) => {
    setEditId(c?.id || null);
    setForm(c ? { nombre:c.nombre, descripcion:c.descripcion||'', icono:c.icono||'🌿' } : EMPTY);
    setModal(true);
  };

  const guardar = async () => {
    if (!form.nombre) return toast.error('Nombre requerido');
    try {
      if (editId) {
        await api.put(`/categorias/${editId}`, form);
        toast.success('Categoria actualizada');
      } else {
        await api.post('/categorias', form);
        toast.success('Categoria creada');
      }
      setModal(false);
      load();
    } catch(e) { toast.error(e.response?.data?.error || 'Error'); }
  };

  const eliminar = async (id) => {
    if (!window.confirm('Desactivar esta categoria?')) return;
    try {
      await api.delete(`/categorias/${id}`);
      toast.success('Categoria desactivada');
      load();
    } catch(e) { toast.error(e.response?.data?.error || 'Error'); }
  };

  return (
    <div>
      <div style={{ background:'#fff', borderBottom:'1px solid var(--border)', padding:'14px 28px', position:'sticky', top:0, zIndex:10, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <h1 style={{ fontSize:18, fontWeight:900, color:'var(--forest)' }}>Categorias</h1>
        <button className="btn btn-primary" style={{ background:'#9FBE6A', color:'#1C3A1E' }} onClick={() => abrir()}>+ Nueva categoria</button>
      </div>

      <div style={{ padding:'24px 28px' }}>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(280px,1fr))', gap:16 }}>
          {categorias.map(c => (
            <div key={c.id} className="card">
              <div className="card-body" style={{ display:'flex', alignItems:'center', gap:16 }}>
                <span style={{ fontSize:40 }}>{c.icono}</span>
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:700, fontSize:15, color:'var(--forest)' }}>{c.nombre}</div>
                  <div style={{ fontSize:12, color:'var(--ink-faint)', marginTop:2 }}>{c.descripcion || 'Sin descripcion'}</div>
                  <div style={{ fontSize:11, color:'var(--ink-faint)', marginTop:4, fontFamily:'monospace' }}>{c.id}</div>
                </div>
                <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
                  <button onClick={() => abrir(c)} className="btn btn-outline btn-sm">Editar</button>
                  <button onClick={() => eliminar(c.id)} style={{ padding:'5px 12px', borderRadius:'var(--r-sm)', border:'none', background:'#fcebeb', color:'#a32d2d', fontWeight:700, fontSize:12, cursor:'pointer' }}>Desactivar</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {modal && (
        <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.4)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:24 }}>
          <div className="card" style={{ width:'100%', maxWidth:480 }}>
            <div className="card-header">
              <span className="card-title">{editId ? 'Editar categoria' : 'Nueva categoria'}</span>
              <button onClick={() => setModal(false)} style={{ background:'none', border:'none', fontSize:20, cursor:'pointer', color:'var(--ink-faint)' }}>✕</button>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label className="form-label">Nombre *</label>
                <input className="form-input" value={form.nombre} onChange={e=>setForm(f=>({...f,nombre:e.target.value}))} placeholder="Ej: Cuidado personal" />
              </div>
              <div className="form-group">
                <label className="form-label">Descripcion</label>
                <input className="form-input" value={form.descripcion} onChange={e=>setForm(f=>({...f,descripcion:e.target.value}))} placeholder="Descripcion breve" />
              </div>
              <div className="form-group">
                <label className="form-label">Icono</label>
                <div style={{ display:'flex', flexWrap:'wrap', gap:8, marginTop:8 }}>
                  {ICONOS.map(ic => (
                    <button key={ic} onClick={() => setForm(f=>({...f,icono:ic}))} style={{ fontSize:24, padding:'6px 10px', borderRadius:'var(--r-sm)', border:`2px solid ${form.icono===ic?'#9FBE6A':'transparent'}`, background: form.icono===ic?'rgba(159,190,106,0.1)':'var(--cream)', cursor:'pointer' }}>{ic}</button>
                  ))}
                </div>
              </div>
              <div style={{ display:'flex', gap:10, marginTop:20 }}>
                <button className="btn btn-primary" style={{ flex:1, background:'#9FBE6A', color:'#1C3A1E' }} onClick={guardar}>
                  {editId ? 'Guardar cambios' : 'Crear categoria'}
                </button>
                <button className="btn btn-outline" onClick={() => setModal(false)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
